import { INITIAL_DENOMINATIONS_STATE } from 'Common/Components/CashCalculator/constants';

export const extractDenominations = cashInfo => {
  const denominations = { ...INITIAL_DENOMINATIONS_STATE };

  if (cashInfo) {
    Object.keys(denominations).forEach(k => {
      const key = k.toLowerCase();
      denominations[k] = cashInfo[key];
    });
  }

  return denominations;
};

export const formatCheckData = checks => {
  return checks.map(c => {
    return { amount: c.Amount, description: c.Description };
  });
};

export const addNewChecks = (currentChecks, newChecks) => {
  const formattedNewChecks = formatCheckData(newChecks);

  if (currentChecks.length !== 0) {
    const checksToAdd = formattedNewChecks.filter(
      newCheck =>
        currentChecks.findIndex(
          check => newCheck.description === check.description
        ) === -1
    );

    return currentChecks.concat(checksToAdd);
  }

  return currentChecks.concat(formattedNewChecks);
};



// WEBPACK FOOTER //
// ./src/pages/mealsummary/helpers/helper.js